import type { ReactElement } from 'react';
import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { CampaignPage } from './CampaignPage';
import { MarketingPage } from './MarketingPage';
import { PostsPage } from './PostsPage';
import { SubscribersPage } from './SubscribersPage';

const gate = (permission: string, element: ReactElement) => <ModuleGate module="marketing" permission={permission}>{element}</ModuleGate>;

/**
 * Einstiegspunkt des Moduls Marketing im Backoffice (KON-170, Schlüssel `marketing`, siehe docs/marketing.md): Kampagnen unter /marketing, Abonnenten unter /marketing/abonnenten.
 * Die öffentlichen Seiten zum Bestätigen und Abmelden (/newsletter/…) stehen in main.tsx, weil sie ohne Anmeldung erreichbar sind.
 */
export const marketingModule: BackofficeModule = {
  key: 'marketing',
  path: '/marketing',
  nav: [
    { label: 'Kampagnen', path: '/marketing' },
    { label: 'Abonnenten', path: '/marketing/abonnenten' },
    { label: 'Beiträge', path: '/marketing/beitraege' },
  ],
  routes: (
    <>
      <Route path="marketing" element={gate('marketing.read', <MarketingPage />)} />
      <Route path="marketing/abonnenten" element={gate('marketing.read', <SubscribersPage />)} />
      <Route path="marketing/beitraege" element={gate('marketing.read', <PostsPage />)} />
      <Route path="marketing/kampagnen/neu" element={gate('marketing.write', <CampaignPage />)} />
      <Route path="marketing/kampagnen/:id" element={gate('marketing.read', <CampaignPage />)} />
    </>
  ),
};
